import {
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_ERROR
} from "./actionTypes"

const initialState = {
  notification: {},
  error: null,
  loading: null
}

const Notification = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_NOTIFICATION:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        notification: { ...state.notification, data: [...state.notification.data, action.payload.data] },
      }

    case UPDATE_NOTIFICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Notification;
